<template>
  <div class="user">
    <div class="photo">
      <img src="/static/img/faces/face-0.jpg" alt="avatar"/>
    </div>
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click.stop="toggleMenu" href="#">
           <span v-if="$auth.user()">
             {{ $auth.user().screenname }}
             <b class="caret"></b>
          </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <el-collapse-transition>
          <ul class="nav" v-show="!isClosed">
            <slot>
              <li>
                <a class="profile-dropdown" href @click.prevent="logout()">
                  <span class="sidebar-mini">
                    <i class="fa fa-sign-out"></i>
                  </span>
                  <span class="sidebar-normal">
                    Quitter
                  </span>
                </a>
              </li>
            </slot>
          </ul>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

  export default {
    components: {
      [CollapseTransition.name]: CollapseTransition
    },
    props: {
      title: {
        type: String,
        default: 'Admin'
      }
    },
    data () {
      return {
        isClosed: true
      }
    },
    methods: {
      toggleMenu () {
        this.isClosed = !this.isClosed
      },
      logout () {
        this.$auth.logout({
            makeRequest: true,
            params: {},
            success: function () {},
            error: function () {},
            redirect: '/login',
        });
      }
    }
  }
</script>
<style>
  .collapsed {
    transition: opacity 1s;
  }
</style>
